import { GlobalAxios } from "../axios/axios-config";
import { IPatientCareCharacter } from "../models/patient-care-character";

const PATIENT_CARE_CHARACTER_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/PatientCareCharacter/PatientCareCharacter";

export const patientCareCharacterList = (params?: any) => {
  return GlobalAxios.get<IPatientCareCharacter[]>(
    PATIENT_CARE_CHARACTER_ROUTE,
    { params },
  );
};
